@import '../../../theme.scss';

verdocs-table {
  width: 100%;
  display: block;
  margin: 0 0 10px 0;
  box-sizing: border-box;
  font-family: $primary-font;

  .table-wrapper {
    margin: 10px 0;
    padding: 0;
  }

  .table {
    width: 100%;
    border: none;
    border-collapse: collapse;
  }

  .row {
    &.header-row {
    }

    &.data-row {
      border: 1px solid #d4d4d8;
      background-color: #ffffff;
    }
  }

  .header-col {
    color: #5c6575;
    font-weight: 600;
    text-align: left;
    padding: 8px 16px;
  }

  .data-col {
    font-weight: 400;
    padding: 8px 16px;
  }
}
